import { useQuery } from "@tanstack/react-query";
import { useField } from "formik";
import AutoComplete from "../autocomplete/Autocomplete";
import { useState } from "react";
import AutoCompleteSelectedItem from "../autocomplete/AutoCompleteSelectedItem";
import { getInteresser } from "../../api/stamdata";
import { IInteresseomraade } from "../../interfaces/accounts";

const InteresseField = ({
  name,
  placeholder,
}: {
  name: string;
  placeholder?: string;
}) => {
  const [inputValue, setInputValue] = useState<string>("");
  const [field, meta, helpers] = useField<IInteresseomraade | null>(name);
  const { data: interesser, isLoading } = useQuery<IInteresseomraade[]>({
    queryKey: ["interesseomraader"],
    queryFn: async function () {
      return getInteresser();
    },
  });

  const items = interesser
    ? interesser
        .filter((f) =>
          f.navn.toLowerCase().includes(inputValue.toLocaleLowerCase()),
        )
        .sort((a, b) => a.navn.localeCompare(b.navn))
    : [];
  if (meta.value?.id) {
    return (
      <AutoCompleteSelectedItem
        onClick={() => helpers.setValue(null)}
        title={meta.value.navn}
      />
    );
  }
  return (
    <AutoComplete
      inputId={name}
      loading={isLoading}
      itemToElement={(item) => <div className="p-2">{item.navn}</div>}
      items={items}
      itemToString={(item) => item?.navn ?? ""}
      onSelectedItemChange={({ selectedItem }) => {
        helpers.setValue(selectedItem ?? null);
        helpers.setTouched(true, false);
      }}
      setInputValue={setInputValue}
      fieldInputProps={field}
      placeholder={placeholder}
    />
  );
};

export default InteresseField;
